import React, { useEffect } from "react";
import * as api from "../../../api/generated-api";
import Button from "../../common/forms/button";
import "./styles/SignatureBlock.scss";
import ReactDOM from "react-dom";

type DocumentSignatureProps = {
  signingPerson?: api.Person;
  signingStatus: api.SigningStatus;
  signatureBlockContent: string;
  onSign?: () => void;
};

export const DocumentSignature = ({
  signingPerson,
  signingStatus,
  signatureBlockContent,
  onSign,
}: DocumentSignatureProps) => {
  if (!signingStatus || !signatureBlockContent) {
    return null;
  }

  const renderSignedSignatureLine = () => {
    const signatureLineElement = document.getElementById(
      "signature-line-container"
    );

    ReactDOM.render(
      <div
        style={{
          fontFamily: "'DealkitSignatureFont'",
          fontSize: "35pt", // this value also needs updated in server/src/views/signatureBlockContent.ejs
          borderBottom: "1px solid black",
          marginRight: "40px",
          verticalAlign: "baseline",
          lineHeight: "20px", // this value also needs updated in server/src/views/signatureBlockContent.ejs
        }}
      >
        {signingPerson.firstName} {signingPerson.lastName}
      </div>,
      signatureLineElement
    );
  };

  const renderSignatureButton = () => {
    const signatureLineElement = document.getElementById(
      "signature-line-container"
    );
    ReactDOM.render(
      <div onClick={onSign}>
        <Button data-testid="button-sign-document" size="medium" type="ghost">
          Click Here
        </Button>
      </div>,
      signatureLineElement
    );
  };

  useEffect(() => {
    if (signingStatus === "requested") {
      renderSignatureButton();
    } else if (signingStatus === "signed" && signingPerson) {
      renderSignedSignatureLine();
    }
  }, []);

  useEffect(() => {
    if (signingStatus === "requested") {
      renderSignatureButton();
    } else if (signingStatus === "signed" && signingPerson) {
      const signedSignatureRegExp = new RegExp("signed-signature-block");
      const signatureBlockContentIncludesSigned = signedSignatureRegExp.test(
        signatureBlockContent
      );

      if (!signatureBlockContentIncludesSigned) {
        renderSignedSignatureLine();
      }
    }
  }, [signingStatus]);

  return (
    <div>
      {signatureBlockContent && (
        <p id="sign-button-container">
          {signingStatus === "requested" && signingPerson && (
            <div
              dangerouslySetInnerHTML={{
                __html: signatureBlockContent,
              }}
            ></div>
          )}
          {signingStatus === "signed" && (
            <div
              dangerouslySetInnerHTML={{
                __html: signatureBlockContent,
              }}
            ></div>
          )}
        </p>
      )}
    </div>
  );
};
